export const formatDateBackendToUi = (dateString: any) => {
  if (!dateString) return "";

  // Parse the date string and handle timezone properly
  const date = new Date(dateString);

  // Use UTC methods to avoid timezone offset issues
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};